var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddUser = function SvgAddUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.556 5.555a3.556 3.556 0 1 1-7.112 0 3.556 3.556 0 0 1 7.112 0M10 16c0 .769.289 1.47.765 2.001H4.222c-1.416 0-2.223-.444-2.223-1.778C1.999 12.667 6 10 9.999 10c1.355 0 2.71.306 3.91.849A3 3 0 0 0 13.001 13a3 3 0 0 0-3 3Zm6-4a1 1 0 0 1 1 1v2h2a1 1 0 0 1 0 2h-2v2a1 1 0 0 1-2 0v-2h-2a1 1 0 0 1 0-2h2v-2a1 1 0 0 1 1-1"
  })));
};
export default SvgAddUser;